<template>
  <div :class="toggleVisibility">
    <div v-if="error" class="error">
      <error-component
        :lang="toggleLang"
        @closed="error = null"
      ></error-component>
    </div>
    <div v-if="toggleLabel" class="field-label is-normal has-text-left">
      <label class="has-text-left"
        ><span>{{ getLabel }}</span></label
      >
    </div>
    <div>
      <div class="columns">
        <div class="column">
          <v-select
            ref="naicsLookup"
            label="title"
            :multiple="toggleMultiple"
            v-model="selected"
            @search="onSearch"
            @input="emitEvent"
            :options="options"
            :placeholder="
              getPlaceholder != null ? getPlaceholder : $t('placeholder')
            "
            :filterable="false"
            :select-on-key-codes="[27, 13]"
          >
            <template slot="option" slot-scope="option">
              <span v-html="option.title" class="titleBigger" /><span
                v-if="toggleCode"
                >&nbsp;&nbsp;<span class="small"
                  >[{{ $t("naics") }}
                  <span v-html="option.naics_code" class="small" />]</span
                ></span
              >
              <br />
              <span
                v-html="option.keyword"
                class="naics-lookup-result-keywords"
              />
            </template>
            <template slot="selected-option" slot-scope="optionSelected">
              <p>
                <span v-html="decodeHTMLEntities(optionSelected.title)" />
                <span v-if="toggleCode"
                  >&nbsp;&nbsp;<span class="small"
                    >[{{ $t("naics") }}
                    <span
                      v-html="decodeHTMLEntities(optionSelected.naics_code)"
                      class="small"
                    />]</span
                  ></span
                >
              </p>
            </template>

            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                <div role="alert" aria-live="assertive">
                  <p>
                    {{ $t("no_option") }} <em>{{ search }}</em>
                  </p>
                </div>
              </template>

              <em v-else style="opacity: 0.8">{{
                getPlaceholder != null ? getPlaceholder : $t("placeholder")
              }}</em>
            </template>
          </v-select>
          <div v-if="toggleSource" class="inlineRight">
            <a
              tabindex="0"
              @keyup.enter="isShowing ^= true"
              @click="isShowing ^= true"
              ><b-icon
                :icon="isShowing ? 'minus-square' : 'plus-square'"
                size="is-small"
                pack="fa"
              ></b-icon
              ><span> Source</span></a
            >
          </div>
          <div v-if="isShowing">
            <base-footer :lang="toggleLang" widget="naics" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@bizpal/open-services-error-component";
import "@bizpal/open-services-footer-widget";
import interaction from "open-services-interaction/src/plugins/interactions-mixin.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import algoliasearch from "algoliasearch/lite";

export default {
  i18n: {
    locale: "en",
    fallbackLocale: "en",
    messages: {
      en: {
        no_option: "Sorry, no matching option for",
        placeholder: "Type to search",
        label: "Select an Industry | Select Industries",
        naics: "NAICS"
      },
      fr: {
        no_option: "Désolé, aucunes options correspondantes pour",
        placeholder: "Tapez pour rechercher",
        label: "Sélectionnez une industrie | Sélectionnez les industries",
        naics: "SCIAN"
      }
    }
  },
  props: {
    lang: {
      type: String,
      default: "en"
    },
    "show-label": {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    "has-source": {
      type: Boolean,
      default: true
    },
    visibility: {
      type: Boolean,
      default: true
    },
    inputCode: {
      type: String,
      default: ""
    },
    "show-code": {
      type: Boolean,
      default: true
    },
    placeholderText: {
      type: String,
      default: null
    }
  },
  mixins: [interaction],
  data: function() {
    return {
      // props is not passing the default value if not present
      // in tag
      mylang: this.toggleLang,
      myLabel: this.label ? this.label : "",
      isMultiple: this.multiple,
      //visible: this.visibility,
      //show: this.showCode,
      indexName:
        this.lang === "fr" ? "naics_2017_lookup_fr" : "naics_2017_lookup_en",
      resetOnOptionsChange: true,
      options: [],
      selected: null,
      resultData: {},
      countLabel: 1,
      error: null,
      isShowing: false,
      interationProduct: "Naics Lookup - Widget",
      previousMulitpleSelection: []
    };
  }, // data
  components: {
    "v-select": vSelect
  },
  mounted: function() {
    this.$i18n.locale = this.toggleLang;
    // algolia search
    var appid = "IQKSBFPSWC";
    var secret = "f8aab81f78e6415f1ea46a4c80c1eb20";
    // eslint-disable-next-line
    var displayKey = "title";
    this.client = algoliasearch(appid, secret);
    this.index = this.client.initIndex(this.indexName);
    if (this.toggleInputCode) {
      this.getName();
    }
  },
  computed: {
    toggleSource: function() {
      return this.hasSource;
    },
    toggleMultiple: function() {
      return this.multiple;
    },
    toggleLang: function() {
      return this.lang == "fr" ? this.lang : "en";
    },
    toggleLabel: function() {
      return this.showLabel;
    },
    getLabel: function() {
      return this.label == "" ? this.$tc("label", this.countLabel) : this.label;
    },
    toggleCode: function() {
      return this.showCode;
    },
    toggleInputCode: function() {
      return this.inputCode;
    },
    toggleVisibility: function() {
      return this.visibility ? "show" : "hide";
    },
    getPlaceholder: function() {
      return this.placeholderText;
    }
  }, // end computed
  watch: {
    //props
    label: function() {
      this.myLabel = this.getLabel;
    },
    multiple: function() {
      this.countLabel = this.multiple ? 2 : 1;
      this.isMultiple = this.multiple ? this.multiple : false;
    },
    lang: function() {
      this.$i18n.locale = this.toggleLang;
      this.indexName =
        this.lang === "fr" ? "naics_2017_lookup_fr" : "naics_2017_lookup_en";
      // reset v-select data
      this.options = [];
      this.selected = null;
      if (this.client) {
        this.index = this.client.initIndex(this.indexName);
      }

      if (this.inputCode) {
        this.getName();
      }
    },
    toggleInputCode: function() {
      if (this.inputCode) {
        this.getName();
      } else {
        this.selected = null;
      }
    },
    selected: function(current) {
      if (current !== null) {
        this.resultData.naics = [];
        if (this.isMultiple) {
          // to remove html code from title
          var tempArray = current.map(el => {
            return {
              code: el.naics_code,
              name: this.decodeHTMLEntities(el.title)
            };
          });
          this.resultData.naics = tempArray;
        } else {
          //not multiple
          this.resultData.naics = new Array({
            code: current.naics_code,
            name: this.decodeHTMLEntities(current.title)
          });
        }
      } else {
        // null
        this.resultData.naics = [];
      }
      this.$emit("change", this.resultData);
    }
  }, // end watch
  methods: {
    // eslint-disable-next-line
    onSearch: function(search, loading) {
      //var self = this;
      if (search != "") {
        this.index.search(
          search,
          {
            hitsPerPage: 20,
            facets: "*"
          },
          this.searchCallback
        );
      }
    }, //end onSearch
    searchCallback: function(err, content) {
      let self = this;
      if (err) {
        // eslint-disable-next-line
        console.error(err);
        self.error = err;
        return;
      }
      sessionStorage.setItem("userQuery", content.query);
      // track keyword not found
      if (content.hits.length == 0) {
        let propsKeyword = {};
        propsKeyword[self.mxKeywordNotFound.properties.keyword] = content.query;
        let propsInteraction = self.mxGetDefaultInteractionProp(
          self.toggleLang,
          self.interationProduct
        );
        let statement = self.mxCreateNodeStatement(
          "k",
          self.mxKeywordNotFound.label,
          propsKeyword
        );
        let statementInteraction = self.mxCreateNodeStatement(
          "n",
          self.mxInteraction.label,
          propsInteraction
        );

        let statementRelationshipKeyWordNotFound = self.mxCreateInteractionRelationshipStatement(
          self.mxInteraction.label,
          propsInteraction.key,
          self.mxKeywordNotFound.relationship,
          self.mxKeywordNotFound.label,
          self.mxKeywordNotFound.properties.timestamp,
          [propsKeyword.timestamp],
          false
        );
        //from mixin
        self.mxSaveInteraction(
          process.env.VUE_APP_NEO4J_URL,
          process.env.VUE_APP_NEO4J_USER,
          process.env.VUE_APP_NEO4J_PWD,
          [
            statement,
            statementInteraction,
            statementRelationshipKeyWordNotFound
          ]
        );

        self.options = [];
      } else {
        self.options = [];
        //if (content.hits.length > 0) this.userQuery = content.query;
        for (var i = 0; i < content.hits.length; i++) {
          //obtain a keyword that matched
          var highlightKeywords = "";
          if (content.hits[i]._highlightResult.keyword != null) {
            var keywords = content.hits[i]._highlightResult.keyword.value;
            keywords = keywords.split(";");
            keywords.forEach(function(item) {
              if (item.indexOf("<em>") != -1) {
                highlightKeywords += item;
                highlightKeywords += ", ";
              }
            });
          }
          if (
            highlightKeywords.length > 0 &&
            highlightKeywords.substring(
              highlightKeywords.length - 2,
              highlightKeywords.length
            ) == ", "
          ) {
            highlightKeywords = highlightKeywords.substring(
              0,
              highlightKeywords.length - 2
            );
          }
          //display info
          self.options.push({
            title: content.hits[i]._highlightResult.title.value,
            naics_code: content.hits[i].naics_code,
            keyword: highlightKeywords
          });
        }
      }
    },
    getName: function() {
      // only search string
      this.index
        .search(this.toggleInputCode, {
          facetFilters: ["naics_code:" + this.toggleInputCode] // to search using sgc attribute
        })
        .then(({ hits }) => {
          if (hits.length == 0) {
            this.selected = null;
            return;
          }
          if (this.isMultiple) {
            this.selected = [
              {
                title: hits[0].title,
                naics_code: hits[0].naics_code
              }
            ];
          } else {
            this.selected = {
              title: hits[0].title,
              naics_code: hits[0].naics_code
            };
          }
          this.emitEvent(this.selected);
        })
        .catch(err => {
          this.error = err;
        });
    }, //end getName
    decodeHTMLEntities: function(str) {
      //let element = document.createElement("div");
      if (str && typeof str === "string") {
        var tmp = document.createElement("div");
        tmp.innerHTML = str;
        return tmp.textContent || tmp.innerText;
      }
      return str;
    }, //end decodeHTMLEntities
    emitEvent: function(current) {
      if (current !== null) {
        if (this.isMultiple) {
          // to remove html code from title
          var tempArray = current.map(el => {
            return {
              code: el.naics_code,
              name: this.decodeHTMLEntities(el.title)
            };
          });
          this.resultData.naics = tempArray;
          if (this.resultData.naics.length == 0) this.options = []; // to clear data
        } else {
          //not multiple
          this.resultData.naics = new Array({
            code: current.naics_code,
            name: this.decodeHTMLEntities(current.title)
          });
        }
      } else {
        // null
        this.resultData.naics = [];
        this.options = []; // to clear data
      }
      //this.$emit("change", this.resultData);

      // save interaction
      if (
        this.resultData.naics.length > 0 &&
        this.previousMulitpleSelection.length < this.resultData.naics.length
      ) {
        this.previousMulitpleSelection = this.resultData.naics;
        let propsKeyword = {};
        let naicsObj = this.resultData.naics.pop();
        // eslint-disable-next-line prettier/prettier
           propsKeyword[this.mxKeywordFound.properties.keyword] = sessionStorage.getItem("userQuery");;
        propsKeyword[this.mxKeywordFound.properties.code] = naicsObj.code;
        propsKeyword[this.mxKeywordFound.properties.code_name] = naicsObj.name;
        let propsInteraction = this.mxGetDefaultInteractionProp(
          this.locale,
          this.interationProduct
        );
        let KeywordStatement = this.mxCreateNodeStatement(
          "k",
          this.mxKeywordFound.label,
          propsKeyword
        );
        let statementInteraction = this.mxCreateNodeStatement(
          "n",
          this.mxInteraction.label,
          propsInteraction
        );

        let statementRelationshipKeyWordFound = this.mxCreateInteractionRelationshipStatement(
          this.mxInteraction.label,
          propsInteraction.key,
          this.mxKeywordFound.relationship,
          this.mxKeywordFound.label,
          this.mxKeywordFound.properties.timestamp,
          [propsKeyword.timestamp],
          false
        );
        //from mixin
        this.mxSaveInteraction(
          process.env.VUE_APP_NEO4J_URL,
          process.env.VUE_APP_NEO4J_USER,
          process.env.VUE_APP_NEO4J_PWD,
          [
            KeywordStatement,
            statementInteraction,
            statementRelationshipKeyWordFound
          ]
        );
      } else {
        this.previousMulitpleSelection = [];
      } // else length > 0
    } // emitEvent
  } //end methods
}; // end export default
</script>

<style scoped>
.v-select {
  width: 100%;
}
div.dropdown.v-select.single.unsearchable {
  width: 100%;
}
div.dropdown-toggle {
  width: 100%;
}
.vs__selected-options .input[type="search"],
.v-select .input[type="search"].form-control {
  width: 100%;
}
.vs__search .input[type="search"] {
  width: 100%;
}
.vs__selected-options {
  width: 100%;
}
.vs__dropdown-option {
  border: 1px solid #e0e0e0;
  border-left-width: 10px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 5px 4px;
  background: white;
  font-family: Arial, Helvetica, sans-serif;
}
.vs__dropdown-option:active,
.vs__dropdown-option:hover,
.vs__dropdown-option:focus,
.vs__dropdown-option--highlight {
  background-color: #ddd;
  color: black;
  padding: 5px 4px;
  border-left-width: 10px;
  border-left-color: #66afe9;
}
.vs__dropdown-menu {
  cursor: pointer;
}
.naics-lookup-result-keywords {
  color: grey;
  font-size: small;
}
.naics-lookup-result-keywords em {
  /* was mark */
  color: black;
  font-weight: bold;
  background-color: transparent;
}
.titleBigger {
  font-size: medium;
}
.titleBigger em {
  /* was mark */
  color: black;
  font-weight: bold;
  background-color: transparent;
}
.inlineRight {
  float: right;
  margin-right: 8px;
}
.show {
  display: block;
}
.hide {
  display: none;
}
.small {
  font-size: small;
}
div.inlineRight a:focus {
  outline: none;
  color: blue;
}
</style>
